<template>
  <div>
    <div class="pt-3">
      <v-row no-gutters>
        <v-col cols="12" md="7" lg="7">
          <div class="pa-2">
            <v-card class="pa-5 rounded-lg" color="var(--g)" flat>
              <h1 class="white--text txtLarge notBold">
                Welcome to
                <span>
                  <b> Integrated Learning Management Platform </b>
                </span>
              </h1>
              <div class="d-flex align-center my-4">
                <v-avatar dark size="100" class="mr-3">
                  <img
                    :src="
                      profile.profile_picture ? profile.profile_picture : ava
                    "
                    alt="avatar"
                    class="obj_fit"
                  />
                </v-avatar>
                <h1 class="txtLarge white--text notBold">
                  {{ profile.name }}
                </h1>
              </div>
              <h4 class="txtSmall white--text notBold">
                Nice to have you back, what an exciting day! Get ready to
                continue your learning.
              </h4>
            </v-card>
            <div
              v-if="dataSet.courseOnProgress && dataSet.courseOnProgress.length"
            >
              <div class="d-flex align-center justify-space-between mt-5">
                <h3 class="color_default">Course on progress</h3>
                <div class="d-flex align-center justify-center">
                  <v-btn v-if="step1 == 1" icon>
                    <v-icon> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    color="black"
                    v-if="step1 > 1"
                    icon
                    @click="step1 -= 1"
                  >
                    <v-icon> mdi-chevron-left </v-icon>
                  </v-btn>

                  <v-btn class="ml-3" v-if="step1 == last1" icon>
                    <v-icon> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-btn
                    class="ml-3"
                    v-if="step1 !== last1"
                    icon
                    @click="step1 += 1"
                  >
                    <v-icon color="black"> mdi-chevron-right </v-icon>
                  </v-btn>
                </div>
              </div>
              <v-card flat class="pa-3 rounded-lg">
                <v-stepper v-model="step1" class="ma-0" flat>
                  <v-stepper-items>
                    <v-stepper-content
                      v-for="(item, i) in dataSet.courseOnProgress"
                      :key="i"
                      style="margin: 0; padding: 0"
                      :step="i + 1"
                    >
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-progress-circular
                            :value="item.coursePercent"
                            size="130"
                            color="var(--g)"
                            width="18"
                            rotate="270"
                            class="progress-circular"
                          >
                            <h3>{{ item.coursePercent }}%</h3>
                          </v-progress-circular>
                        </v-col>
                        <v-col cols="9">
                          <h2 class="txtMediumSmall color_default">
                            {{ item.courseTitle }}
                          </h2>
                          <h5 class="txtSmall notBold txtRunning">
                            {{ item.courseCategoryName }}
                          </h5>
                          <div class="my-2">
                            <v-row no-gutters>
                              <v-col cols="12">
                                <div class="d-flex align-end">
                                  <v-icon class="txtRunning">mdi-book</v-icon>
                                  <h5 class="txtSmall notBold txtRunning ml-2">
                                    {{ item.courseTotalModule }} Module
                                  </h5>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div class="d-flex align-end">
                                  <v-icon class="txtRunning">mdi-book</v-icon>
                                  <h5 class="txtSmall notBold txtRunning ml-2">
                                    {{ item.courseTotalSection }} Section
                                  </h5>
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                          <v-btn
                            dark
                            class="btn mt-3"
                            block
                            color="var(--g)"
                            :to="`/course/inclass/${item.courseId}`"
                          >
                            <b class="txtSmall"> Continue Course </b>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card>
            </div>

            <div v-if="dataSet.courseUpcoming && dataSet.courseUpcoming.length">
              <div class="d-flex align-center justify-space-between mt-5">
                <h3 class="color_default">Upcoming Course</h3>
                <div class="d-flex align-center justify-center">
                  <v-btn v-if="step2 == 1" icon>
                    <v-icon> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn
                    color="black"
                    v-if="step2 > 1"
                    icon
                    @click="step2 -= 1"
                  >
                    <v-icon> mdi-chevron-left </v-icon>
                  </v-btn>

                  <v-btn class="ml-3" v-if="step2 == last2" icon>
                    <v-icon> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-btn
                    class="ml-3"
                    v-if="step2 !== last2"
                    icon
                    @click="step2 += 1"
                  >
                    <v-icon color="black"> mdi-chevron-right </v-icon>
                  </v-btn>
                </div>
              </div>
              <v-card flat class="pa-3 rounded-lg">
                <v-stepper v-model="step2" class="ma-0" flat>
                  <v-stepper-items>
                    <v-stepper-content
                      v-for="(item, i) in dataSet.courseUpcoming"
                      :key="i"
                      style="margin: 0; padding: 0"
                      :step="i + 1"
                    >
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-progress-circular
                            :value="item.coursePercent"
                            size="130"
                            color="var(--g)"
                            width="18"
                            rotate="270"
                            class="progress-circular"
                          />
                        </v-col>
                        <v-col cols="9">
                          <h2 class="txtMediumSmall color_default">
                            {{ item.courseTitle }}
                          </h2>
                          <h5 class="txtSmall notBold txtRunning">
                            {{ item.courseCategoryName }}
                          </h5>
                          <div class="my-2">
                            <v-row no-gutters>
                              <v-col cols="12">
                                <div class="d-flex align-end">
                                  <v-icon class="txtRunning">mdi-book</v-icon>
                                  <h5 class="txtSmall notBold txtRunning ml-2">
                                    {{ item.courseTotalModule }} Module
                                  </h5>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div class="d-flex align-end">
                                  <v-icon class="txtRunning">mdi-book</v-icon>
                                  <h5 class="txtSmall notBold txtRunning ml-2">
                                    {{ item.courseTotalSection }} Section
                                  </h5>
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                          <v-btn
                            dark
                            class="btn mt-3"
                            block
                            color="var(--g)"
                            :to="`/course/inclass/${item.courseId}`"
                          >
                            <b class="txtSmall"> Continue Course </b>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-card>
            </div>
          </div>
          <div class="pa-2">
            <v-card class="rounded-lg pa-3 mb-3" flat>
              <div class="d-flex align-center mb-3">
                <v-icon color="var(--g)" class="mr-3">
                  mdi-information-outline
                </v-icon>
                <h5>Announcement:</h5>
              </div>
              <div class="d-flex align-start" v-if="announ.length">
                <v-carousel
                  v-model="model"
                  height="150"
                  hide-delimiters
                  show-arrows-on-hover
                >
                  <v-carousel-item v-for="(item, i) in announ" :key="i">
                    <div @click="viewAnouncement(item)" class="cursor">
                      <h3 class="text-center mb-3" v-snip="2">
                        {{ item.title }}
                      </h3>
                      <div class="d-flex align-start">
                        <v-icon class="mr-3" color="var(--g)">
                          mdi-circle-small
                        </v-icon>
                        <h5
                          v-if="item.description"
                          v-html="item.description"
                          v-snip="3"
                        ></h5>
                        <h5 v-else>No Description</h5>
                      </div>
                    </div>
                  </v-carousel-item>
                </v-carousel>
              </div>
              <div
                class="d-flex align-center justify-center"
                style="height: 150px"
                v-else
              >
                <h3>No announcements for now</h3>
              </div>
            </v-card>
          </div>
        </v-col>
        <!-- LIST MODULE -->
        <v-col cols="12" md="5" lg="5" class="pa-2">
          <v-card
            :class="showTimeline ? 'historyDefault' : 'rounded-lg'"
            flat
            style="overflow: hidden"
            min-height="280px"
          >
            <div
              :class="
                showTimeline
                  ? 'trigger_timeline mt-10 rounded-lg'
                  : 'trigger_timeline rounded-lg'
              "
            >
              <v-btn
                class="btn_trigger_timeline"
                icon
                small
                @click="showTimeline = !showTimeline"
              >
                <v-icon v-if="!showTimeline">mdi-chevron-up</v-icon>
                <v-icon v-if="showTimeline">mdi-chevron-down</v-icon>
              </v-btn>
            </div>
            <div>
              <div
                :class="
                  showTimeline
                    ? 'colorWhite expand_history rounded-t-lg'
                    : 'collapse_history rounded-t-lg'
                "
              >
                <v-card flat style="overflow: hidden" class="rounded-t-lg">
                  <history-course-scholar :deadline="deadline" />
                </v-card>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="pa-3">
      <view-announ
        :v_announ="v_announ"
        :inventory="inventory"
        @close="v_announ = false"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapState } from "vuex";
import historyCourseScholar from "../../components/historyCourseScholar/historyCourseScholar.vue";
import ViewAnnoun from "../Announcement/viewAnnoun.vue";
export default {
  components: { historyCourseScholar, ViewAnnoun },
  name: "adminOverview",
  computed: {
    ...mapState({
      ava: (state) => state.ava_lg,
      profile: (state) => state.profile,
    }),
  },

  data() {
    return {
      dataSet: null,
      loading: false,
      runningPersen: 80,
      upcomingPersen: 0,
      toggle: false,
      completed: true,
      showTimeline: false,
      offsetTop: 0,
      step1: 1,
      step2: 1,
      last1: null,
      last2: null,
      deadline: null,
      v_announ: false,
      announ: [],
      model: 0,
      inventory: null,
    };
  },
  mounted() {
    this.fetchData();
    this.fetchDeadline();
    this.getAnounc();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/overview`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.loading = false;
          this.dataSet = data;

          this.last1 = data.courseOnProgress
            ? data.courseOnProgress.length
            : null;
          this.last2 = data.courseUpcoming ? data.courseUpcoming.length : null;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchDeadline() {
      this.loading = true;
      let data = {
        path: `scholar/overview/deadline`,
      };
      this.$store.dispatch("chat/getData", data).then((data) => {
        this.deadline = data.data;
        this.loading = false;
      });
    },
    getAnounc() {
      this.loading = true;
      let data = {
        path: `announcement/scholar`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.announ = data;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    viewAnouncement(item) {
      this.inventory = item;
      this.v_announ = true;
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
  },
};
</script>

<style scoped>
.txtRunning {
  color: #a2aaad;
}
.expand_member {
  position: relative;
  height: max-content;
  transition: 0.5 all;
  margin-bottom: 10px;
}
.collapse_member {
  position: relative;
  overflow: hidden;
  height: max-content;
  transition: 0.5 all;
  margin-bottom: 10px;
}
.control_height {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: -100px;
  left: 0;
  width: 100%;
  border-radius: 10px;
  z-index: -1;
}
.btn_toogle {
  color: transparent;
}
.expand_history {
  position: relative;
  height: max-content;
  transition: 0.5 all;
}
.collapse_history {
  position: relative;
  overflow: hidden;
  height: max-content;
  transition: 0.5 all;
  padding: 20px;
}
.trigger_timeline {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: -100px;
  left: 0;
  width: 100%;
  z-index: -1;
}
.btn_trigger_timeline {
  color: transparent;
}
.historyDefault {
  height: max-content;
  z-index: 0;
}
.coming_course {
  margin-right: 10px;
}
.complete_course {
  margin-left: 10px;
}
.txtLarge {
  font-size: 36px;
}
.txtMedium {
  font-size: 32px;
}
.txtMediumSmall {
  font-size: 24px;
}
.txtSmall {
  font-size: 18px;
}
.txt_date {
  font-size: 14px;
}
.colorGrey {
  background-color: #edf1f0;
}
.colorWhite {
  background-color: white;
}
@media (max-width: 768px) {
  .coming_course {
    margin: 0;
  }
  .complete_course {
    margin-top: 20px;
    margin-left: 0px;
  }
  .expand_member {
    position: relative;
    height: max-content;
    transition: 0.5 all;
    margin-bottom: 10px;
  }
  .collapse_member {
    position: relative;
    overflow: hidden;
    height: 90px;
    transition: 0.5 all;
    margin-bottom: 10px;
  }
  .control_height {
    position: absolute;
    display: flex;
    justify-content: center;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 10px;
    z-index: 1;
  }
  .btn_toogle {
    color: #a2aaad;
  }
  .expand_history {
    padding: 0 20px 0 20px;
    position: relative;
    height: max-content;
    overflow: hidden;
    transition: 0.5 all;
  }
  .collapse_history {
    padding: 30px;
    position: relative;
    overflow: hidden;
    height: 80px;
    transition: 0.5 all;
  }
  .trigger_timeline {
    position: absolute;
    display: flex;
    justify-content: center;
    background-color: white;
    top: 0;
    padding: 5px;
    height: 35px;
    left: 0;
    width: 100%;
    z-index: 2;
  }
  .btn_trigger_timeline {
    color: #a2aaad;
  }
  .historyDefault {
    width: 100%;
    height: 100vh;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
    background-color: #edf1f0;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .txtLarge {
    font-size: 20px;
  }
  .txtMedium {
    font-size: 20px;
  }
  .txtMediumSmall {
    font-size: 18px;
  }
  .txtSmall {
    font-size: 12px;
  }
}
</style>
